/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const concordium_chain_about = () => `Concordium is a science-based proof-of-stake blockchain, the first in the world with identification built into the protocol and designed to meet regulatory requirements. Concordium CCD is a standard blockchain asset with customizable options, directly in Layer-1. Concordium supports secure transfers and immediate transaction settlement for multiparty transactions built in Layer-1. Concordium Smart Contracts in Layer-1 are stateless smart contracts with numerous possibilities for governed operations. These capabilities can be applied to different sectors and industries, such as IoT, Supply Chain Finance, and Mobility-as-a-service, as well as tackling interoperability between other platforms and blockchains.`
